module.exports = __webpack_public_path__ + "images/whatsapp-box---a03bf435e8f54887d4aeb7d88216debb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app/images/whatsapp-box.png
// module id = 390
// module chunks = 0